export function queryParamsArray(parameterName: string, list: string[], params?: URLSearchParams): URLSearchParams {
  return list.reduce((params, parameterValue) => {
    params.append(parameterName, parameterValue);
    return params;
  }, params ?? new URLSearchParams());
}
